export default {
  BASE_URL: '/admin',
  api: [
    {
      name: 'login',
      desc: '登录',
      method: 'POST',
      path: '/login'
    },
    {
      name: 'sign-up',
      desc: '注册',
      method: 'POST',
      path: '/register'
    },
    {
      name: 'logout',
      desc: '注销',
      method: 'POST',
      path: '/logout'
    },
    {
      name: 'isUsernameExists',
      desc: '检查用户名是否存在',
      method: 'GET',
      path: '/isExistUsername/{username}'
    },
    {
      name: 'checkPhone',
      desc: '检查手机号码是否存在',
      method: 'GET',
      path: '/isExitsPhone/{phone}'
    },
    {
      name: 'currentUser',
      desc: '获取当前用户',
      method: 'GET',
      path: '/user'
    },
    {
      name: 'functionCodes',
      desc: '获取当前用户的功能编码',
      method: 'GET',
      path: '/user/fun'
    },
    {
      name: 'modifyPassword',
      desc: '修改密码',
      method: 'PUT',
      path: '/user/updatePassword'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/app/index.js